<template>
  <pp-app
    v-if="!isLoading && isSettingsAvailable"
    :class="{
      'is-mobile': isMobile,
      'widget-list-open': isMobile && isWidgetOpen
    }"
    :style="cssVars"
    data-iframe-width
  >
    <div
      class="pb-5"
      :class="{
        'pl-4 pr-5': !isMobile || !isWidgetOpen,
        'd-flex justify-center align-center': isMobile && isWidgetOpen
      }"
    >
      <help-dialog
        v-model="showDialog"
      />
      <widget-list
        v-show="isWidgetOpen"
      />
      <chat-button
        v-if="!isWidgetOpen"
        class="mt-5"
        @showWidgetListEvent="closeHelpDialog"
      />
    </div>
  </pp-app>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import ChatButton from '@/components/chat-button/ChatButton'
import WidgetList from '@/components/widget-list/WidgetList'
import HelpDialog from '@/components/help-dialog/HelpDialog'

export default {
  name: 'App',
  components: {
    'chat-button': ChatButton,
    'widget-list': WidgetList,
    'help-dialog': HelpDialog
  },
  data () {
    return {
      showDialog: false,
      isIframeReady: false,
      isDataReady: false
    }
  },
  computed: {
    ...mapGetters({
      backgroundColor: 'backgroundColor',
      textColor: 'textColor',
      isWidgetOpen: 'isWidgetOpen',
      isLoading: 'isLoading',
      isMobile: 'isMobile',
      parentHeight: 'parentHeight',
      parentWidth: 'parentWidth',
      settings: 'settings',
      isSettingsAvailable: 'isSettingsAvailable'
    }),
    cssVars () {
      let cssVars = ''
      cssVars += this.parentWidth ? `--pp-parent-width:${this.parentWidth}px;` : ''
      cssVars += this.parentHeight ? `--pp-parent-height:${this.parentHeight}px;` : ''
      cssVars += this.backgroundColor ? `--pp-theme-color:${this.backgroundColor};` : ''
      cssVars += this.textColor ? `--pp-primary-button-text-color:${this.textColor};` : ''
      return cssVars
    },
    isAppReady () {
      return this.isIframeReady && this.isDataReady
    }
  },
  watch: {
    isAppReady: {
      deep: true,
      handler () {
        if (this.isIframeReady && this.isDataReady) {
          this.setIsLoading(false)
        }
      }
    }
  },
  mounted () {
    // Needed for anchor tel: href links to work properly in Mobile Safari
    const isMobileSafari = !!navigator.userAgent.match(/iPhone/i) && !!navigator.userAgent.match(/Safari/i)
    this.setIsMobileSafari(isMobileSafari)

    // when iframe resizer has loaded
    window.iFrameResizer = {
      onReady: () => {
        // watch the page info and update in state the parent frame sizes
        // (used for determining mobile view)
        window.parentIFrame.getPageInfo((pageInfo) => {
          this.setParentSizeInfo(pageInfo)
          this.isIframeReady = true
        })
      }
    }

    Promise.all([
      this.getCustomWidgetSettings(),
      this.getWidgetManagerSettings()
    ])
      .catch((e) => {
        this.$ppAnalytics.trackEvent({
          action: 'multi_channel_api_error',
          label: 'widget-load'
        })
      })
      .finally(() => {
        if (window.Cypress) {
          this.isIframeReady = true
        }
        this.isDataReady = true
      })
  },
  methods: {
    ...mapActions({
      getCustomWidgetSettings: 'getCustomWidgetSettings',
      getWidgetManagerSettings: 'getWidgetManagerSettings'
    }),
    ...mapMutations({
      setIsLoading: 'SET_IS_LOADING',
      setIsWidgetOpen: 'SET_IS_WIDGET_OPEN',
      setParentSizeInfo: 'SET_PARENT_SIZE_INFO',
      setIsMobileSafari: 'SET_IS_MOBILE_SAFARI'
    }),
    closeHelpDialog () {
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss">
body {
  height: fit-content;
}

.pp-app {
  display: inline-block;
  min-width: 100px;

  --pp-theme-color: #656e8b;
  --pp-primary-button-text-color: #{$white};
}

.widget-list-open {
  display: flex;
  height: var(--pp-parent-height, 100vh);
  width: var(--pp-parent-width, 100vw);

  &:after {
    background-color: black;
    content: "";
    height: var(--pp-parent-height, 100vh);
    left: 0;
    opacity: .5;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
  }
}
</style>
